import React from 'react';
import { cn } from './cn';

// The "Double-Bezel" — a machined-hardware container: an outer tray (subtle warm tint + hairline
// ring) cradling an inner core with its own surface, an inset top highlight, and a concentric
// (smaller) radius. Every premium card/panel in the app is built on this.
export function Bezel({ children, className, shellClassName, ...rest }) {
    return (
        <div className={cn('rounded-squircle bg-espresso/[0.035] p-1.5 ring-1 ring-espresso/10 shadow-ambient', shellClassName)}>
            <div className={cn('rounded-squircle-inner bg-cream-50 shadow-inner-hi', className)} {...rest}>
                {children}
            </div>
        </div>
    );
}
